import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: "/common/currencies", params });
